import { atom } from '@reatom/framework'

import { AsyncStateN } from '@blade/std-lib'

import type { WalletSwapInputModel } from './reatom-wallet-swap-input'
import type { WalletSwapPairModel } from './reatom-wallet-swap-pair'

export type SwapValidationError =
  | { type: 'LackOfFunds' }
  | { type: 'NoCurrency' }
  | { type: 'ZeroAmount' }
  | { type: 'SelectPool' }
  | { type: 'NoPools' }

export const reatomWalletSwapValidation = (
  inputModel: WalletSwapInputModel,
  poolModel: WalletSwapPairModel,
) => {
  const {
    inCurrencyInputModel,
    inCurrencyAtom,
    outCurrencyAtom,
    inputAmountAtom,
  } = inputModel

  const validationErrorAtom = atom((ctx): SwapValidationError | undefined => {
    const baseCurrency = ctx.spy(inCurrencyAtom)
    const quoteCurrency = ctx.spy(outCurrencyAtom)

    if (!baseCurrency || !quoteCurrency) {
      return { type: 'NoCurrency' }
    }

    const selectedPool = ctx.spy(poolModel.selectedPoolAtom)
    const poolsState = ctx.spy(poolModel.poolsStateAtom)

    if (AsyncStateN.isSuccess(poolsState) && poolsState.value.length === 0) {
      return {
        type: 'NoPools',
      }
    }

    if (!AsyncStateN.isNotInitiated(poolsState) && !selectedPool) {
      return {
        type: 'SelectPool',
      }
    }

    const inputAmount = ctx.spy(inputAmountAtom)
    if (inputAmount.eq(0)) {
      return {
        type: 'ZeroAmount',
      }
    }

    const baseAmount = ctx.spy(inCurrencyInputModel.amountAtom)
    const baseBalance = ctx.spy(inCurrencyInputModel.balanceAtom)
    if (baseAmount.gt(baseBalance)) {
      return { type: 'LackOfFunds' }
    }
    return undefined
  }, 'validationErrorAtom')

  return {
    validationErrorAtom,
  }
}

export type WalletSwapValidationModel = ReturnType<
  typeof reatomWalletSwapValidation
>
